import { useState } from 'react';
import { Suggestion } from '@components/FormElements/AutoSuggest';
import { JobTitle } from '../types';
import useTitleSuggestions from './useTitleSuggestions';

export default function useJobTitleAutoSuggest() {
  const [suggestions, setSuggestions] = useState<Suggestion[] | []>([]);
  const { getSuggestions } = useTitleSuggestions();

  function updateSuggestions(input: string) {
    const suggestionResults = getSuggestions(input);
    setSuggestions(suggestionResults);
  }

  function fetchSuggestions(input: string) {
    if (input.length >= 2) {
      updateSuggestions(input);
    } else {
      setSuggestions([]);
    }
  }

  function toAutoSuggestValue(
    value: JobTitle | undefined
  ): Suggestion | undefined {
    if (!value) return;

    return {
      displayText: value.jobTitle,
      data: value
    };
  }

  return {
    suggestions,
    updateSuggestions,
    fetchSuggestions,
    toAutoSuggestValue
  };
}
